var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComDel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3394,
    cy: 10,
    r: 9.5,
    fill: "#696570",
    stroke: "#A6A3AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1847 5.89987C15.3905 5.69401 15.3905 5.36025 15.1847 5.15439C14.9788 4.94854 14.6451 4.94854 14.4392 5.15439L10.3394 9.25439L6.23947 5.15439C6.03362 4.94854 5.69987 4.94854 5.49401 5.15439C5.28816 5.36025 5.28816 5.69401 5.49401 5.89987L9.5939 9.99987L5.49375 14.1001C5.28789 14.306 5.28789 14.6397 5.49375 14.8456C5.6996 15.0515 6.03335 15.0515 6.2392 14.8456L10.3394 10.7453L14.4395 14.8456C14.6454 15.0515 14.9791 15.0515 15.185 14.8456C15.3908 14.6397 15.3908 14.306 15.185 14.1001L11.0848 9.99987L15.1847 5.89987Z",
    fill: "#A6A3AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComDel);
export default __webpack_public_path__ + "static/media/icon_com_del.ea1979beca5e6516c07e0a75881ad64a.svg";
export { ForwardRef as ReactComponent };